var map = {
	"./account.svg": 17792,
	"./allot.svg": 57457,
	"./app.svg": 50816,
	"./approve.svg": 67314,
	"./assets.svg": 11780,
	"./auth.svg": 457,
	"./authorizationLetter.svg": 67626,
	"./avatar.svg": 60784,
	"./backOfIDcard.svg": 95064,
	"./backlogTemp.svg": 8414,
	"./bell.svg": 85228,
	"./businessLicense.svg": 63378,
	"./businessLicense1.svg": 17951,
	"./calculate.svg": 8633,
	"./chance.svg": 8919,
	"./commonCalculate.svg": 27436,
	"./contract.svg": 92845,
	"./crm.svg": 86177,
	"./customer.svg": 22631,
	"./derate.svg": 70028,
	"./dictionary.svg": 731,
	"./download.svg": 85703,
	"./equipmentMaintain.svg": 26078,
	"./equipmentRepairs.svg": 75529,
	"./equipment_statistics.svg": 55005,
	"./examineApproval.svg": 10741,
	"./examineCancel.svg": 74666,
	"./examinePass.svg": 25375,
	"./examineRefuse.svg": 39096,
	"./examineSubmit.svg": 9852,
	"./facility.svg": 37452,
	"./finance.svg": 35531,
	"./fittings.svg": 85031,
	"./flow.svg": 23387,
	"./frontOfIDcard.svg": 45442,
	"./handlemanage.svg": 52016,
	"./history.svg": 83169,
	"./iconMp3.svg": 48794,
	"./iconMp4.svg": 60421,
	"./insurance.svg": 38617,
	"./invoice.svg": 6484,
	"./lease.svg": 26831,
	"./lettingRate.svg": 22312,
	"./logistics.svg": 85476,
	"./logo1.svg": 46527,
	"./logo2.svg": 67500,
	"./loss.svg": 59378,
	"./lowGoods.svg": 94243,
	"./maintain.svg": 28816,
	"./menu.svg": 19954,
	"./number.svg": 20012,
	"./order.svg": 63857,
	"./organization.svg": 28018,
	"./pending.svg": 9592,
	"./personalWorkingHours.svg": 52329,
	"./pollingCheck.svg": 67060,
	"./proceed.svg": 79803,
	"./procesApprove.svg": 75226,
	"./processing.svg": 98206,
	"./project.svg": 97126,
	"./recall.svg": 34212,
	"./receive.svg": 31106,
	"./refabrication.svg": 86170,
	"./refund.svg": 59025,
	"./regect.svg": 96785,
	"./regect_back.svg": 57693,
	"./rental.svg": 33169,
	"./reportForms.svg": 19470,
	"./resource.svg": 62363,
	"./role.svg": 30471,
	"./screen.svg": 37532,
	"./sendRepairs.svg": 74929,
	"./serve.svg": 96912,
	"./set.svg": 49589,
	"./sign.svg": 42928,
	"./state.svg": 77998,
	"./statistics.svg": 76938,
	"./time-outline.svg": 57305,
	"./tool.svg": 86689,
	"./transfer.svg": 21198,
	"./urgentRecall.svg": 14963,
	"./visit.svg": 4496,
	"./waitDo.svg": 56239,
	"./warehouse.svg": 57216,
	"./workbench.svg": 44014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;